import React, { Component } from 'react';
import Title from 'antd/lib/typography/Title';
import Form from '../../../lib/ui/form';
import { Row, Button, Divider, Tabs } from 'antd';
import HierarchyAssigner from './hierarchy_assigner';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import BasicInformation from './basic_information';
import PasswordPolicySetting from './password_policy'
import MakerCheckerSetting from './maker_checker_setting';
const backup_fields = [
    {
        index: 'ftp_address',
        name: "FTP Address",
        type: 'text'
    },
    {
        index: 'username',
        name: "Username",
        type: 'text'
    },
    {
        index: 'password',
        name: "Password",
        type: 'password'
    },
    {
        index: 'dir_location',
        name: "Directory Location",
        type: 'text'
    },
    {
        index: 'schedule',
        name: "Schedule",
        type: 'schedule'
    }

]

const recon_setting_fields=[
    {
        index:'max_hour',
        name:"Max Hours before flush",
        help_text:"Maximum number of hours to hold uncategorized transaction in a system.",
        type:'number'
    }
]

const setting_items=[
    {
        title:"Basic Information",
        content:<BasicInformation/>
    },
    {
        title:"Hierarchy Access",
        content:<HierarchyAssigner />
    },
    {
        title:"Security Setting",
        content:<PasswordPolicySetting/>
    },
    {
        title:"Maker Checker",
        content:<MakerCheckerSetting/>
    }

]
class AppSetting extends Component {
    constructor(props) {
        super(props)

        this.state = {
        }
    }

    render() {
        return (
            <div>
                <BasicHeader no_back title="App Settings"
                    menu_items={setting_quick_menu}
                    />
            <div className='default-card' style={{
                padding:8,
                paddingLeft:16,
                paddingRight:16
              }}>
                  <div id="top-plugin"></div>
                {/* <Title  style={{
                    textAlign:'left'
                }}>Application Settings</Title> */}
                <Tabs tabPosition='top' onTabClick={()=>{
                    console.log("clicked")
                    // var elmnt = document.getElementById("top-plugin");
                    // elmnt.scrollIntoView();
    
                }}>
                {
                    setting_items.map((item,index)=>{
                        return <Tabs.TabPane key={index} tab={item.title}>
                            <div style={{
                                minHeight:500,
                            }}>
                            {item.content}
                            </div>
                        </Tabs.TabPane>
                    })
                }
    
                </Tabs>
                </div>

                </div>
        );
    }
    componentDidMount(){
        try{
            window.header_assigner.assignTitle("Application Setting");
      
        }catch(e){}
    }

}

export default AppSetting;
